import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
export function FinalCTASection() {
  return <section className="py-20 bg-brand-dark text-white" data-id="element-686">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-687">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-688">
          Stop carrying chemicals where they don't belong.
        </h2>
        <p className="text-xl text-gray-300 mb-10" data-id="element-689">
          Spray smarter with Precision Pro Sprayers.
        </p>
        <Link to="/contact" data-id="element-690">
          <button className="inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-14 px-8 text-lg" data-id="element-691">
            <ShoppingCart className="w-5 h-5 mr-2" data-id="element-692" />
            Add to Cart
          </button>
        </Link>
      </div>
    </section>;
}